// extracted by mini-css-extract-plugin
module.exports = {"bar":"e_wab","seg":"e_xab","better":"e_yab","expected":"e_zab","worse":"e_Aab","legend":"e_Bab","legendItem":"e_Cab","swatch":"e_Dab"};